import { render, staticRenderFns } from "./priceAdjustmentModal.vue?vue&type=template&id=48b1f574&scoped=true"
import script from "./priceAdjustmentModal.vue?vue&type=script&lang=js"
export * from "./priceAdjustmentModal.vue?vue&type=script&lang=js"
import style0 from "./priceAdjustmentModal.vue?vue&type=style&index=0&id=48b1f574&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48b1f574",
  null
  
)

export default component.exports